import { Alert, Col, DatePicker, Form, Input, Row, Space } from "antd";
import { FormItemHiddenUi, SwitchUi } from "../../ui";
import { TiposNotificacionSelect } from "./TiposNotificacionSelect";
import { CanalesNotificacionSelect } from "./CanalesNotificacionSelect";
import { EstadosNotificacionSelect } from "./EstadosNotificacionSelect";
import { DateFormats } from "../../../types/typesConstants";
import { EmpleadosSelect } from "../../rrhh/empleados/reusable/EmpleadosSelect";

export const NotificacionForm = () => {
  const form = Form.useFormInstance();
  const esmasivo = Form.useWatch("esmasivo", form);
  return (
    <>
      <FormItemHiddenUi name="id" />
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={24}>
          <Form.Item
            label="Mensaje"
            name="mensaje"
            rules={[{ required: true, message: "El mensaje es obligatorio" }]}
          >
            <Input.TextArea cols={3} placeholder="Ingrese mensaje" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={12}>
          <Form.Item
            label="Tipo de notificación"
            name="tipo"
            rules={[{ required: true, message: "El tipo es obligatorio" }]}
          >
            <TiposNotificacionSelect
              placeholder="[-Seleccione-]"
              optionRender={(option) => (
                <Alert
                  message={option.data.label}
                  type={String(option.data.label).toLowerCase()}
                ></Alert>
              )}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="App referencia" name="app">
            <Input placeholder="App referencia (Opcional)" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={12}>
          <Form.Item
            label="Canal"
            name="canal"
            rules={[{ required: true, message: "El canal es obligatorio" }]}
          >
            <CanalesNotificacionSelect placeholder="[-Seleccione-]" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Estado" name="estado">
            <EstadosNotificacionSelect placeholder="[-Seleccione-]" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={12}>
          <Form.Item
            label="¿Es general el envió?"
            name="esmasivo"
            valuePropName="checked"
          >
            <SwitchUi />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Fecha envió"
            name="fechaenvio"
            rules={[
              { required: true, message: "La fecha de envio es obligatoria" },
            ]}
          >
            <DatePicker format={DateFormats.frontend} />
          </Form.Item>
        </Col>
      </Row>
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        style={esmasivo && { display: "none" }}
      >
        <Col span={24}>
          <Form.Item
            label="Empleados"
            name="empleadosdestinatario"
            rules={[
              {
                required: !esmasivo,
                message: "Los empleados son obligatorios",
              },
            ]}
          >
            <EmpleadosSelect
              mode="multiple"
              labelInValue
              allowClear
              style={{ width: "100%" }}
              name="empleados"
              placeholder="[-Seleccione-]"
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
